/* Boat Harbour Marine - collection filters. No dependencies. */
(function () {
  'use strict';
  if (window.__bhmFilters) return;
  window.__bhmFilters = true;

  var REGIONS = ['filters', 'toolbar', 'grid'];
  var ctrl = null;
  var priceTimer = null;

  function root() { return document.getElementById('bhm-collection'); }
  function isMobile() { return window.matchMedia('(max-width: 989px)').matches; }

  function formFor(el) {
    var r = root();
    return r ? r.querySelector('[data-bhm-form]') : null;
  }

  function buildUrl(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    var group = form.querySelector('[data-bhm-price-group]');
    var rangeMax = group ? parseFloat(group.getAttribute('data-range-max')) : NaN;
    var minIn = form.querySelector('[data-bhm-price="min"]');
    var maxIn = form.querySelector('[data-bhm-price="max"]');
    var minV = minIn && minIn.value !== '' ? parseFloat(minIn.value) : null;
    var maxV = maxIn && maxIn.value !== '' ? parseFloat(maxIn.value) : null;
    var dropMin = minV === null || minV <= 0;
    var dropMax = maxV === null || (!isNaN(rangeMax) && maxV >= rangeMax);
    fd.forEach(function (value, key) {
      if (value === '') return;
      if (minIn && key === minIn.name && dropMin) return;
      if (maxIn && key === maxIn.name && dropMax) return;
      params.append(key, value);
    });
    var base = form.getAttribute('action') || location.pathname;
    var q = params.toString();
    return base + (q ? '?' + q : '');
  }

  function snapshot(r) {
    var s = { open: {}, expanded: {}, scroll: 0, searches: {} };
    r.querySelectorAll('details.bhm-g').forEach(function (d) {
      var k = d.getAttribute('data-key');
      s.open[k] = d.open;
      if (d.classList.contains('is-expanded')) s.expanded[k] = true;
      var q = d.querySelector('[data-bhm-search]');
      if (q && q.value) s.searches[k] = q.value;
    });
    var f = r.querySelector('.bhm-f__form');
    var side = r.querySelector('.bhm-side');
    s.scroll = isMobile() ? (f ? f.scrollTop : 0) : (side ? side.scrollTop : 0);
    return s;
  }

  function restore(r, s) {
    r.querySelectorAll('details.bhm-g').forEach(function (d) {
      var k = d.getAttribute('data-key');
      if (k in s.open) d.open = s.open[k];
      if (s.expanded[k]) setExpanded(d, true);
      if (s.searches[k]) {
        var q = d.querySelector('[data-bhm-search]');
        if (q) { q.value = s.searches[k]; runSearch(q); }
      }
    });
    var f = r.querySelector('.bhm-f__form');
    var side = r.querySelector('.bhm-side');
    if (isMobile()) { if (f) f.scrollTop = s.scroll; } else if (side) { side.scrollTop = s.scroll; }
    initPrice(r);
  }

  function go(url, push) {
    var r = root();
    if (!r) { location.href = url; return; }
    var sid = r.getAttribute('data-section-id');
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    r.classList.add('is-loading');
    var u = new URL(url, location.origin);
    u.searchParams.delete('section_id');
    var clean = u.pathname + u.search;
    u.searchParams.set('section_id', sid);

    fetch(u.toString(), { signal: ctrl ? ctrl.signal : undefined, credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = doc.getElementById('bhm-collection');
        if (!nr) throw new Error('missing layout');
        var s = snapshot(r);
        REGIONS.forEach(function (k) {
          var a = r.querySelector('[data-bhm-region="' + k + '"]');
          var b = nr.querySelector('[data-bhm-region="' + k + '"]');
          if (a && b) a.replaceWith(document.importNode(b, true));
        });
        restore(r, s);
        if (push !== false) history.pushState({ bhm: true }, '', clean);
        r.classList.remove('is-loading');
        if (!isMobile()) {
          var top = r.getBoundingClientRect().top;
          if (top < -40) window.scrollTo({ top: window.scrollY + top - 16, behavior: 'smooth' });
        }
        document.dispatchEvent(new CustomEvent('bhm:filters-updated', { detail: { url: clean } }));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = clean;
      });
  }

  /* ---------- drawer ---------- */
  var lastFocus = null;
  function openDrawer() {
    var r = root(); if (!r) return;
    lastFocus = document.activeElement;
    r.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var btn = r.querySelector('[data-bhm-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var close = r.querySelector('.bhm-f__close');
    if (close) setTimeout(function () { close.focus(); }, 50);
  }
  function closeDrawer() {
    var r = root(); if (!r || !r.classList.contains('is-open')) return;
    r.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var btn = r.querySelector('[data-bhm-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- show more / search ---------- */
  function setExpanded(g, on) {
    g.classList.toggle('is-expanded', on);
    var b = g.querySelector('[data-bhm-more]');
    if (b) b.textContent = on ? b.getAttribute('data-less') : b.getAttribute('data-more');
  }
  function runSearch(input) {
    var g = input.closest('.bhm-g');
    var q = input.value.trim().toLowerCase();
    var any = false;
    g.classList.toggle('is-searching', q.length > 0);
    g.querySelectorAll('.bhm-o').forEach(function (li) {
      var hit = !q || (li.getAttribute('data-label') || '').indexOf(q) !== -1;
      li.classList.toggle('is-filtered-out', !hit);
      if (hit) any = true;
    });
    var none = g.querySelector('.bhm-g__none');
    if (none) none.hidden = any;
  }

  /* ---------- price ---------- */
  function paintPrice(group) {
    var lo = group.querySelector('[data-bhm-range="min"]');
    var hi = group.querySelector('[data-bhm-range="max"]');
    var fill = group.querySelector('.bhm-price__fill');
    var max = parseFloat(lo.max) || 1;
    var a = Math.min(parseFloat(lo.value), parseFloat(hi.value));
    var b = Math.max(parseFloat(lo.value), parseFloat(hi.value));
    fill.style.setProperty('--lo', (a / max * 100) + '%');
    fill.style.setProperty('--hi', (100 - b / max * 100) + '%');
  }
  function initPrice(scope) {
    (scope || document).querySelectorAll('[data-bhm-price-group]').forEach(paintPrice);
  }
  function syncFromRange(range) {
    var group = range.closest('[data-bhm-price-group]');
    var lo = group.querySelector('[data-bhm-range="min"]');
    var hi = group.querySelector('[data-bhm-range="max"]');
    if (parseFloat(lo.value) > parseFloat(hi.value)) {
      if (range === lo) lo.value = hi.value; else hi.value = lo.value;
    }
    group.querySelector('[data-bhm-price="min"]').value = parseFloat(lo.value) > 0 ? lo.value : '';
    group.querySelector('[data-bhm-price="max"]').value = parseFloat(hi.value) < parseFloat(hi.max) ? hi.value : '';
    paintPrice(group);
  }
  function syncFromInput(input) {
    var group = input.closest('[data-bhm-price-group]');
    var which = input.getAttribute('data-bhm-price');
    var range = group.querySelector('[data-bhm-range="' + which + '"]');
    var v = input.value === '' ? (which === 'min' ? 0 : range.max) : input.value;
    range.value = v;
    paintPrice(group);
  }

  /* ---------- events ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('#bhm-collection')) return;
    if (t.matches('[data-bhm-search]')) return;
    if (t.matches('[data-bhm-sort]')) { var f0 = formFor(t); if (f0) go(buildUrl(f0)); return; }
    var form = t.closest('[data-bhm-form]');
    if (!form) return;
    if (t.matches('[data-bhm-range]')) { syncFromRange(t); go(buildUrl(form)); return; }
    if (t.matches('[data-bhm-price]')) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () { go(buildUrl(form)); }, 150);
      return;
    }
    go(buildUrl(form));
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('#bhm-collection')) return;
    if (t.matches('[data-bhm-search]')) runSearch(t);
    else if (t.matches('[data-bhm-range]')) syncFromRange(t);
    else if (t.matches('[data-bhm-price]')) syncFromInput(t);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    var t = e.target;
    if (e.key === 'Enter' && t.matches && t.matches('[data-bhm-price]')) {
      e.preventDefault();
      clearTimeout(priceTimer);
      var form = t.closest('[data-bhm-form]');
      if (form) go(buildUrl(form));
    }
    if (e.key === 'Enter' && t.matches && t.matches('[data-bhm-search]')) e.preventDefault();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-bhm-form]');
    if (!form) return;
    e.preventDefault();
    go(buildUrl(form));
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var r = root();
    if (!r || !r.contains(t)) return;

    var link = t.closest('a[data-bhm-link]');
    if (link) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      go(link.href);
      return;
    }
    var pager = t.closest('[data-bhm-region="grid"] a[href*="page="]');
    if (pager && !(e.metaKey || e.ctrlKey || e.shiftKey)) {
      e.preventDefault();
      go(pager.href);
      var top = r.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
      return;
    }
    if (t.closest('[data-bhm-open]')) { openDrawer(); return; }
    if (t.closest('[data-bhm-close]')) { closeDrawer(); return; }
    var more = t.closest('[data-bhm-more]');
    if (more) {
      var g = more.closest('.bhm-g');
      setExpanded(g, !g.classList.contains('is-expanded'));
    }
  });

  window.addEventListener('popstate', function () {
    if (root()) go(location.href, false);
  });

  window.addEventListener('resize', function () {
    if (!isMobile()) closeDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPrice(); });
  } else {
    initPrice();
  }
})();
